import useAuthenticatedClients from './useAuthenticatedClients';
import { useQuery } from 'react-query';
import { queryKeys } from './../constants';

export default function useRoles(refetchInterval?: number) {
  const { getRolesClient } = useAuthenticatedClients();
  const { ROLES_QUERY_KEY } = queryKeys;

  return useQuery(
    ROLES_QUERY_KEY,
    () => {
      return getRolesClient().then(client => client.getRoles());
    },
    { refetchInterval: refetchInterval ?? false }
  );
}
